import { SubsCustomRoutes } from './subscription';
import { AdminUserCustomRoutes } from './user';
import { ShopCustomRoutes } from './shop';
import { ProductCustomRoutes } from './product';
import { NewsCustomRoutes } from './news';
import { AdvancedFunctionCustomRoutes } from './advancedFunction';
import { EPaymentCustomRoutes } from './e_payment';

export default [
  ...SubsCustomRoutes,
  ...AdminUserCustomRoutes,
  ...ShopCustomRoutes,
  ...ProductCustomRoutes,
  ...NewsCustomRoutes,
  ...AdvancedFunctionCustomRoutes,
  ...EPaymentCustomRoutes,
]


// WEBPACK FOOTER //
// ./src/routes/customRoutes.js